import { makeTag } from '../../svg/utils';
import type { NodeStyle } from '../NodeStyle';
import { nodeStyleBackgroundColors, nodeStyleOutlineColors } from './style';

const OUTLINE_WIDTH = 3;
const OUTLINE_GAP = 3;
const OUTLINE_OFFSET = OUTLINE_WIDTH / 2 + OUTLINE_GAP;
export const OUTLINE_TOTAL_SIZE = OUTLINE_WIDTH + OUTLINE_GAP;

export const drawRectangleBackground = (
  width: number,
  height: number,
  style: NodeStyle,
): string =>
  `${
    style.background === undefined
      ? ''
      : makeTag('rect', {
          fill: nodeStyleBackgroundColors[style.background],
          x: 0,
          y: 0,
          width,
          height,
        })
  }${
    style.outline === undefined
      ? ''
      : makeTag('rect', {
          fill: 'none',
          x: -OUTLINE_OFFSET,
          y: -OUTLINE_OFFSET,
          width: width + 2 * OUTLINE_OFFSET,
          height: height + 2 * OUTLINE_OFFSET,
          stroke: nodeStyleOutlineColors[style.outline],
          'stroke-width': OUTLINE_WIDTH,
        })
  }`;

export const drawSquareBackground = (size: number, style: NodeStyle): string =>
  drawRectangleBackground(size, size, style);

export const drawCircleBackground = (
  radius: number,
  style: NodeStyle,
): string =>
  `${
    style.background === undefined
      ? ''
      : makeTag('circle', {
          cx: 0,
          cy: 0,
          fill: nodeStyleBackgroundColors[style.background],
          r: radius,
        })
  }${
    style.outline === undefined
      ? ''
      : makeTag('circle', {
          cx: 0,
          cy: 0,
          fill: 'none',
          r: radius + OUTLINE_OFFSET,
          stroke: nodeStyleOutlineColors[style.outline],
          'stroke-width': OUTLINE_WIDTH,
        })
  }`;
